import React from "react";
import ProjectMapPage from "./ProjectMapPage";
import geojsonData from "../geojsonData/ThikaHeights";

const ThikaHeights = () => {
  const project_id = "PRJ00076";
  const title = "Thika Heights";

  const mapConfig = {
    minZoom: 9,
    zoom: 10,
    bounds: [
      [41.22282, -74.46321],
      [40.416, -72.57],
    ],
    searchPrefix: "og",
    styleConfig: {
      mode: "plot_status",
      sizeField: "plot_size",
    },
  };

  const isPrimePlot = (plotNo) => {
    // Extract the numeric part from plot number (e.g., "TH8" -> 8)
    const plotNumber = parseInt(plotNo.replace(/[^0-9]/g, ""), 10);
    return (
      (plotNumber >= 8 && plotNumber <= 20) ||
      (plotNumber >= 35 && plotNumber <= 43)
    );
  };

  const customTypeColorFunction = (plotsInfo) => {
    const isPrime = isPrimePlot(plotsInfo.plot_no);
    const landSizeRaw = plotsInfo.plot_size;

    let fillColor = null; // Default to allow SharedMapComponent to use default size colors

    if (landSizeRaw) {
      const landSizeHectares = parseFloat(landSizeRaw.replace(" HA", ""));
      const landSizeAcres = landSizeHectares * 2.47105;

      const primeColors = {
        Eighth: "#7f00ff", // Purple
        Quarter: "#e231aa", // Pink
        Half: "#ff8c00", // Dark Orange
        Acre: "#8b0000", // Dark Red
        "2 Acres": "#228b22", // Forest Green
        "5 Acres": "#ff4500", // Orange Red
      };

      const sizeRanges = {
        Eighth: { min: 0, max: 0.19 },
        Quarter: { min: 0.2, max: 0.3 },
        Half: { min: 0.4, max: 0.6 },
        Acre: { min: 0.8, max: 1.3 },
        "2 Acres": { min: 1.8, max: 2.5 },
        "5 Acres": { min: 4.5, max: Infinity },
      };

      if (isPrime) {
        const matchingSize = Object.entries(sizeRanges).find(
          ([size, range]) => {
            return landSizeAcres >= range.min && landSizeAcres <= range.max;
          }
        );
        if (matchingSize) {
           fillColor = primeColors[matchingSize[0]];
        }
      }
    }

    return {
      fillColor: fillColor, // If null, SharedMapComponent will calculate default color
      color: isPrime ? "#ffd700" : "black", // Gold border for prime
      weight: isPrime ? 3 : 2,
    };
  };

  const customLegendItems = [
    { color: "#7f00ff", label: "Prime Eighth" },
    { color: "#e231aa", label: "Prime Quarter" },
    { color: "#ff8c00", label: "Prime Half" },
    { color: "#8b0000", label: "Prime Acre" },
    { color: "#228b22", label: "Prime 2 Acres" },
    { color: "#ff4500", label: "Prime 5 Acres" },
  ];

  return (
    <ProjectMapPage
      projectId={project_id}
      title={title}
      geojsonData={geojsonData}
      mapConfig={mapConfig}
      customTypeColorFunction={customTypeColorFunction}
      customLegendItems={customLegendItems}
      viewProjectLink="https://www.optiven.co.ke/plots-in-ngong/achievers-paradise-ngong-kimuka-phase2/"
      fillOfferLink="https://docs.google.com/forms/d/e/1FAIpQLSeq-h_ydPVfvofXJj1FNvHBRtB_f7soDmVfM2Bvquy4H7L6VA/viewform"
    />
  );
};

export default ThikaHeights;
